import { createTheme, MantineColorsTuple } from "@mantine/core";

// Shade 0 = lightest, shade 9 = darkest / near-black screen background.
// Per the approved Figma: the wizard is a dark theme (deep navy screens and
// cards), not light - shade 9 here is the actual screen background.
// Shades 7 and 9 are exact values pulled via Figma Inspect (named styles
// "EMPWR Navy" and "Broncos Naby" respectively); the rest of the ramp is
// interpolated between/around them.
const navyBlue: MantineColorsTuple = [
  "#dbe4f7",
  "#b8c9ef",
  "#8fa8e2",
  "#6688d3",
  "#3f66bf",
  "#2650a8",
  "#163b85",
  "#001450",
  "#000f3c",
  "#000b2d",
];

// Broncos orange - primary CTA / headline accent color.
// Shade 5 is exact (Figma named style "Broncos Orange", #F05623); it's also
// primaryShade below, so every default-shade Button/color usage gets it.
const broncosOrange: MantineColorsTuple = [
  "#ffece4",
  "#ffd3c2",
  "#ffb192",
  "#ff8c5e",
  "#f67238",
  "#f05623",
  "#d5451a",
  "#b53810",
  "#942c08",
  "#742206",
];

// Glowing blue border/accent seen throughout the Figma frames (card edges,
// decorative corner brackets). Shade 6 is exact (Figma Inspect, unnamed
// fill on the border/frame vector, #0067FF); rest of ramp built around it.
const glowBlue: MantineColorsTuple = [
  "#e0edff",
  "#b8d6ff",
  "#8ac0ff",
  "#5aa8ff",
  "#2f90ff",
  "#0078ff",
  "#0067ff",
  "#0052cc",
  "#003d99",
  "#002966",
];

export const theme = createTheme({
  primaryColor: "broncosOrange",
  primaryShade: 5,
  fontFamily: "'Open Sans', Arial, sans-serif",
  // Figma headline font is "Beachwood" (Swell Type, Tall UltraBold Italic,
  // 900) - a paid commercial typeface, now licensed and self-hosted (see
  // app.scss's @font-face). Oswald stays as the fallback in case the
  // self-hosted file ever fails to load.
  headings: {
    fontFamily: "'Beachwood', 'Oswald', 'Open Sans', Arial, sans-serif",
    fontWeight: "700",
  },
  colors: {
    navyBlue,
    broncosOrange,
    glowBlue,
  },
});

/** @deprecated use `theme` */
export const baseTheme = theme;
/** @deprecated use `theme` */
export const tabletTheme = theme;
/** @deprecated use `theme` */
export const laptopTheme = theme;
